import { useEffect } from 'react'
import { trackExperimentViewed } from '../events/trackExperimentViewed'
import { useExperiment } from './useExperiment'

export const useTrackExperimentViewed = () => {
  const { isOn } = useExperiment()

  useEffect(() => {
    if (!isOn) return

    trackExperimentViewed()
  }, [isOn])
}
